import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Gallery from './components/Gallery';
import AdminPanel from './components/AdminPanel';

const App = () => {
  return (
    <div>
      <AdminPanel />
      <Gallery />
    </div>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 